import { render, staticRenderFns } from "./CategoryProps.vue?vue&type=template&id=c3fbebb8&scoped=true"
import script from "./CategoryProps.vue?vue&type=script&lang=js"
export * from "./CategoryProps.vue?vue&type=script&lang=js"
import style0 from "./CategoryProps.vue?vue&type=style&index=0&id=c3fbebb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fbebb8",
  null
  
)

export default component.exports